// extracted by mini-css-extract-plugin
export default {"heading":"MainTable_heading__utxKn"};